import { Link } from 'preact-router';
import useModal from '../hooks/useModal';
import Modal from './ui/Modal';
import Menu from './Menu';

export default function Header() {
    const { isModalShowing, toggleModal } = useModal();

    const back = () => {
        window.history.go(-1);
    }

    return (
        <header className="header fixed-top vw-100">
            <Modal isShowing={isModalShowing} hide={() => toggleModal('MainMenu')} title="Menu" id="MainMenu">
                {isModalShowing.MainMenu && <Menu />}
            </Modal>
            <nav className="navbar navbar-light bg-light">
                <div className="container">
                    <Link className="nav-home" href="/">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#555" class="bi bi-house-fill" viewBox="0 0 16 16">
                            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z" />
                            <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z" />
                        </svg>
                    </Link>
                    <Link className="nav-home" onClick={back}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#555" class="bi bi-skip-backward-fill" viewBox="0 0 16 16">
                            <path d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z" />
                        </svg>
                    </Link>
                    <Link className="nav-home" onClick={() => toggleModal('MainMenu')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="32" fill="#555" class="bi bi-skip-backward-fill" viewBox="0 0 16 16">
                            <path d="M16 3L4 3" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M16 8L4 8" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M16 13L4 13" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </Link>
                </div>
            </nav>
        </header>
    );
}